import React, { Component } from 'react';
import formDataSchema from '../../../schema/idle-tat-report';
// import Select2 from '../../../../components/FormComponent/select2';
// import Inputlayer from '../../../../components/FormComponent/Input';
// import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import Datepicker from '../../../components/FormComponent/Date';
import DateRange from '../../../components/FormComponent/DateRange';
import networkList from '../../../constants/networkList';

const {homepage} = networkList;
class Idle_TAT_Report extends Component {
    print = () => {
        window.print();
    }
    render() {
        return (
            <div>
                {/* <div className="row mb-2 ml-5 mr-5 download">
                        <button className="btn btn-success text-capitalize float-left" onClick={this.print}><img src="/assets/images/icons/download1.png" alt="download" /> <span> Download Report</span></button>                   
                </div> */}
                <div className="card m-5 card-table">
                    <div className="card-header bg8">
                       <div className="clearfix">
                            <div className="float-left pt-1">
                                Idle TAT Report
                            </div>
                            <div className=" row col-xl-9 float-right">
                            {formDataSchema.feilds
                                    .map((feild, key) => {

                                        if (feild.element === 'input') {
                                            return (

                                                // <div
                                                //     className={`${feild.className
                                                //         ? feild.className
                                                //         : 'col'} ${feild.name}`}
                                                //     key={key}>
                                                //     <Inputlayer
                                                //         {...this.props}
                                                //         {...this.state}
                                                //         feildData={feild}
                                                //     />
                                                // </div>
                                                <div class="input-group col-7">
                                                <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Counsellor Name"/>
                                                <div class="input-group-append">
                                                    <button class="btn btn-primary btn-sm" type="button"><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                </div>
                                                </div>
                                            )
                                        }
                                        if (feild.element === 'daterange') {
                                                return (
                                                    <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                 <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text}: </p>
                                                <DateRange
                                              
                                                {...this.props}
                                                {...this.state}                                              
                                                     />
                                                     
                                        </div>
                                                )                                                    
                                                    }
                                                

                                //              if (feild.element === 'date') {
                                //     return (
                                //         <div
                                //             className={`${feild.className
                                //                 ? feild.className
                                //                 : 'col '} ${feild.name}`}
                                //             key={key}>
                                //              <p className="data-label text-white w-75 mb-1 pt-1 text-right pr-2">{feild.text}</p>
                                //             <Datepicker
                                //                 // Queuedata={filtereData}
                                //                 selectdata={feild}
                                //                 {...this.props}
                                //                 {...this.state}
                                //             // onselectChanges={this
                                //             //     .onChange
                                //             //     .bind(this)} 
                                //             />
                                //         </div>
                                //     )

                                // }
                                    })}
                            </div>
                        </div>

                    </div>
                    <div className="financial-table table-responsive">
                        <table className="table table-hover table-bordered mb-0" id="myTable">
                            <thead>
                                <tr>

                                    <td>S.no</td>
                                    <td>Date</td>
                                    <td>Counsellor Name</td>
                                    <td>Idle Start time</td>
                                    <td>Idle End time</td>
                                    <td>Difference</td>
                                    <td>Idle Reason</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>01</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>02</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>03</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>04</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>05</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>06</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>07</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>08</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>09</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                                <tr>
                                    <td>10</td>
                                    <td>11-02-2020</td>
                                    <td>FC Name Lorem Ipsum</td>
                                    <td>08:00 AM</td>
                                    <td>02:00 PM</td>
                                    <td>06:00 Hrs</td>
                                    <td>Lorem ipsum dummy text.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default Idle_TAT_Report;